let setCurrentLightbox = null;
let setCurrentPreview = null;
let hoverDelay;

export const openLightbox = (lightboxDetails) => {
  if (lightboxDetails) {
    setCurrentLightbox(lightboxDetails);
  }    
  setCurrentPreview('');
}

export const updateLightbox = (dataFromChild) => {
  setCurrentLightbox = dataFromChild;
}

export const handleHover = (previewDetails, type) => {
  clearTimeout(hoverDelay)
  if (type === 'mouseenter') {
    hoverDelay = setTimeout(() => setCurrentPreview(previewDetails), 250);
  }
}

export const updatePreview = (dataFromChild) => {
  setCurrentPreview = dataFromChild;
}